// extracted by mini-css-extract-plugin
module.exports = {"aside":"aside_aside__hT8_t","content":"aside_content__trYOa"};